import { useQuery } from 'react-query';
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { QueryOptions, QueryResult } from '../../../../shared/types/query';
import { useBrandAuthConfig } from '../../configuration/components/BrandAuthConfigProvider';
import { ApiServerInfo } from '../types/api-server-info';

export function useGetApiServerInfo(options?: QueryOptions<ApiServerInfo>): QueryResult<ApiServerInfo> {
  const http = useHttpClient();
  const brandAuthConfig = useBrandAuthConfig();

  const checkBeVersion = (apiServerInfo: ApiServerInfo, BEversion: number) => {
    return apiServerInfo
      ? parseInt(apiServerInfo.apiServerVersion.split('.')[1], 10) >= BEversion
      : false;
  };

  return useQuery({
    ...options,
    queryKey: ['discovery/apiServerInfo', brandAuthConfig],
    queryFn: async () => {
      return http.request<ApiServerInfo>({
        method: 'get',
        url: '/.discovery/.apiserverinfo',
        params: {
          brandId: brandAuthConfig.bid,
        }
      }).then(result => {
        return {
          ...result.data,
          isQ2_2026_OrHigher_api: checkBeVersion(result.data, 13),
          isQ3_2026_OrHigher_api: checkBeVersion(result.data, 14),
          isQ4_2026_OrHigher_api: checkBeVersion(result.data, 15),
        }
      })
    }
  })
}
